import dayjs from "dayjs"

export const dayIsGreaterThanToday = (date: dayjs.Dayjs) => {
  const today = dayjs(new Date()).startOf("day")
  return !date.startOf("day").isBefore(today)
}
